export type Movie = {
  id: string;
  title: string;
  type: string;
  year: number;
  country: string;
  genres: string[];
  actors: string[];
  director: string;
  rating: number;
  poster: string;
  cover: string;
  summary: string;
};

export const movies: Movie[] = [
  {
    id: "m001",
    title: "星际边缘",
    type: "电影",
    year: 2024,
    country: "美国",
    genres: ["科幻", "冒险", "剧情"],
    actors: ["林澈", "苏晚", "陆沉", "何静"],
    director: "陈默",
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20silhouette%20against%20a%20giant%20glowing%20planet%2C%20minimalist%20composition%2C%20dramatic%20rim%20lighting%2C%20deep%20navy%20and%20cyan%20color%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-001&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20still%20of%20a%20vast%20futuristic%20space%20station%20above%20a%20deep%20blue%20planet%2C%20moody%20atmosphere%2C%20volumetric%20light%2C%20deep%20navy%20and%20cyan%20color%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-001&orientation=landscape",
    summary:
      "一支深空探索舰队在星际边缘发现了一颗会发出低语的未知行星，船员们必须在理智与好奇心之间做出抉择。影片以恢弘的宇宙奇观与细腻的人性刻画，讲述了一段关于孤独与希望的旅程。",
  },
  {
    id: "m002",
    title: "长安谜案",
    type: "电视剧",
    year: 2024,
    country: "中国",
    genres: ["古装", "悬疑", "剧情"],
    actors: ["沈砚", "柳清歌", "裴叙"],
    director: "顾长风",
    rating: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20costume%20drama%20poster%2C%20a%20cloaked%20figure%20in%20traditional%20hanfu%20holding%20a%20lantern%20in%20a%20misty%20old%20city%20alley%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-002&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20city%20at%20night%20with%20lanterns%20and%20mist%2C%20traditional%20architecture%20silhouettes%2C%20moody%20atmosphere%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-002&orientation=landscape",
    summary:
      "天宝年间，长安城接连发生离奇命案。大理寺少卿与画师联手查案，在繁华街市的表象下，牵出一桩盘踞朝野多年的隐秘往事。",
  },
  {
    id: "m003",
    title: "山海之城",
    type: "电影",
    year: 2023,
    country: "中国",
    genres: ["奇幻", "剧情", "冒险"],
    actors: ["江野", "温以宁", "方舟"],
    director: "叶知秋",
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20movie%20poster%20of%20a%20floating%20mountain%20city%20above%20misty%20clouds%2C%20lone%20traveler%20on%20a%20stone%20bridge%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20teal%20and%20warm%20gold%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-003&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20landscape%20of%20an%20ancient%20mountain%20city%20floating%20among%20clouds%20at%20golden%20hour%2C%20epic%20scale%2C%20moody%20atmosphere%2C%20deep%20teal%20and%20warm%20gold%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-003&orientation=landscape",
    summary:
      "传说中漂浮于云海之上的山海之城只在百年一现。一个失去记忆的少年为寻找身世踏上旅途，却在城门前发现，整座城市的存亡与自己息息相关。",
  },
  {
    id: "m004",
    title: "暗涌",
    type: "电视剧",
    year: 2024,
    country: "中国",
    genres: ["都市", "悬疑", "剧情"],
    actors: ["韩枫", "秦岚", "周慕"],
    director: "林深",
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20modern%20urban%20thriller%20poster%2C%20a%20businessman%20silhouette%20seen%20through%20rainy%20glass%20window%20at%20night%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20cool%20blue%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-004&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20city%20skyline%20in%20rain%20with%20reflective%20streets%2C%20moody%20urban%20atmosphere%2C%20deep%20navy%20and%20cool%20blue%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-004&orientation=landscape",
    summary:
      "一场看似意外的商业并购，撕开了一家老牌企业光鲜外表下的裂痕。年轻的投资总监在追查真相时，逐渐发现自己也是这场暗涌中的一枚棋子。",
  },
  {
    id: "m005",
    title: "声生不息",
    type: "综艺",
    year: 2024,
    country: "中国",
    genres: ["音乐", "真人秀"],
    actors: ["群星嘉宾"],
    director: "节目组",
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20music%20variety%20show%20poster%2C%20a%20singer%20silhouette%20under%20a%20warm%20spotlight%20with%20stage%20haze%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20plum%20and%20warm%20amber%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-005&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20concert%20stage%20with%20warm%20spotlights%20and%20crowd%20silhouettes%2C%20energetic%20atmosphere%2C%20deep%20plum%20and%20warm%20amber%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-005&orientation=landscape",
    summary:
      "来自不同年代的实力唱将同台竞演，用经典老歌与全新改编碰撞出跨世代的音乐火花。每期围绕一个主题，用歌声讲述时代故事。",
  },
  {
    id: "m006",
    title: "流浪者",
    type: "电影",
    year: 2023,
    country: "法国",
    genres: ["剧情", "公路"],
    actors: ["陆川", "艾玛·洛朗"],
    director: "让·皮埃尔",
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20road%20movie%20poster%2C%20a%20solitary%20traveler%20walking%20along%20an%20empty%20country%20road%20at%20dusk%20with%20a%20backpack%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20teal%20and%20soft%20orange%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-006&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20empty%20countryside%20road%20through%20golden%20fields%20at%20sunset%20with%20distant%20mountains%2C%20moody%20atmosphere%2C%20deep%20teal%20and%20soft%20orange%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-006&orientation=landscape",
    summary:
      "一个失去工作的中年人搭上一辆开往南方的旧巴士，沿途遇到形形色色的陌生人。影片以缓慢而克制的镜头，记录了一段关于告别与重新出发的旅程。",
  },
  {
    id: "m007",
    title: "迷雾追凶",
    type: "电视剧",
    year: 2025,
    country: "英国",
    genres: ["犯罪", "悬疑", "剧情"],
    actors: ["艾利克斯·里德", "莫拉·凯恩"],
    director: "汤姆·哈迪",
    rating: 9.0,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20poster%2C%20a%20detective%20silhouette%20in%20a%20trench%20coat%20under%20foggy%20streetlight%20at%20night%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20cold%20grey%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-007&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20foggy%20harbor%20town%20at%20night%20with%20dim%20streetlights%20and%20misty%20water%2C%20moody%20atmosphere%2C%20deep%20navy%20and%20cold%20grey%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-007&orientation=landscape",
    summary:
      "一座被海雾笼罩的小镇接连发生失踪案，退休警探被迫重返岗位。随着调查深入，他发现自己要面对的不只是凶手，还有整座小镇共同的秘密。",
  },
  {
    id: "m008",
    title: "追光者",
    type: "电影",
    year: 2024,
    country: "中国",
    genres: ["青春", "励志", "剧情"],
    actors: ["许阳", "夏晴", "顾森"],
    director: "沈亦然",
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20coming%20of%20age%20movie%20poster%2C%20a%20young%20runner%20sprinting%20on%20a%20track%20at%20golden%20sunrise%2C%20backlit%20silhouette%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20teal%20and%20warm%20gold%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-008&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20running%20track%20at%20golden%20sunrise%20with%20long%20shadows%2C%20hopeful%20atmosphere%2C%20deep%20teal%20and%20warm%20gold%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-008&orientation=landscape",
    summary:
      "小镇少年为了追逐短跑梦想来到大城市，却在伤病与质疑中一度迷失。一次偶然的相遇，让他重新理解了奔跑的意义，也照亮了属于自己的那束光。",
  },
  {
    id: "m009",
    title: "风起南洋",
    type: "电视剧",
    year: 2023,
    country: "中国",
    genres: ["年代", "家族", "剧情"],
    actors: ["陈国栋", "苏婉仪", "林嘉文"],
    director: "黄启铭",
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20poster%2C%20a%20family%20silhouette%20standing%20on%20a%20colonial%20pier%20at%20dusk%20with%20a%20ship%20in%20the%20distance%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20teal%20and%20muted%20amber%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-009&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20colonial%20era%20southern%20seaside%20town%20at%20dusk%20with%20wooden%20piers%20and%20junks%2C%20nostalgic%20atmosphere%2C%20deep%20teal%20and%20muted%20amber%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-009&orientation=landscape",
    summary:
      "上世纪初，一个闽南家族漂洋过海在南洋扎根。三代人的沉浮起落，串起一段跨越半世纪的商海传奇与血脉深情。",
  },
  {
    id: "m010",
    title: "无声告白",
    type: "电影",
    year: 2025,
    country: "美国",
    genres: ["剧情", "家庭"],
    actors: ["杰西卡·华", "丹尼尔·李"],
    director: "格蕾丝·陈",
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20movie%20poster%2C%20a%20mother%20and%20child%20silhouette%20by%20a%20window%20with%20soft%20light%20in%20an%20empty%20room%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20teal%20and%20soft%20peach%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-010&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20quiet%20suburban%20house%20interior%20at%20dusk%20with%20warm%20window%20light%2C%20melancholic%20atmosphere%2C%20deep%20teal%20and%20soft%20peach%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-010&orientation=landscape",
    summary:
      "移民家庭的母亲与女儿在语言与文化的隔阂中渐行渐远。一次意外的信笺，让两代人不得不重新面对那些从未说出口的爱与遗憾。",
  },
  {
    id: "m011",
    title: "奔跑吧少年",
    type: "综艺",
    year: 2025,
    country: "中国",
    genres: ["竞技", "户外", "真人秀"],
    actors: ["群星嘉宾"],
    director: "节目组",
    rating: 7.6,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20outdoor%20variety%20show%20poster%2C%20a%20group%20of%20runners%20silhouette%20on%20a%20mountain%20trail%20at%20sunrise%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20teal%20and%20energetic%20orange%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-011&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20mountain%20trail%20at%20sunrise%20with%20colorful%20flags%20and%20energy%2C%20adventurous%20atmosphere%2C%20deep%20teal%20and%20energetic%20orange%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-011&orientation=landscape",
    summary:
      "一群少年在山水之间展开体能、智力与团队协作的多重挑战。节目用真实的任务记录成长瞬间，传递永不言弃的运动精神。",
  },
  {
    id: "m012",
    title: "医者仁心",
    type: "电视剧",
    year: 2024,
    country: "中国",
    genres: ["医疗", "职业剧", "剧情"],
    actors: ["陆铭", "方雨桐", "周正道"],
    director: "赵启明",
    rating: 8.8,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20poster%2C%20a%20doctor%20silhouette%20in%20a%20hospital%20corridor%20with%20cool%20light%20and%20long%20shadow%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20teal%20and%20clean%20white%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-012&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20modern%20hospital%20corridor%20with%20soft%20light%20and%20clean%20lines%2C%20serious%20atmosphere%2C%20deep%20teal%20and%20clean%20white%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-012&orientation=landscape",
    summary:
      "急诊科里，一群年轻医生在生死之间学习成长。面对资源、伦理与人情的重重考验，他们始终坚守着那句朴素的誓言——医者仁心。",
  },
  {
    id: "m013",
    title: "极夜",
    type: "电影",
    year: 2025,
    country: "中国",
    genres: ["悬疑", "犯罪", "剧情"],
    actors: ["段野", "白鹿", "程皓"],
    director: "岑寂",
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%2C%20a%20lone%20figure%20standing%20under%20a%20single%20streetlight%20in%20a%20snowstorm%20at%20night%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20cold%20grey%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-013&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20snowy%20northern%20town%20street%20at%20night%20with%20dim%20streetlights%2C%20moody%20atmosphere%2C%20deep%20navy%20and%20cold%20grey%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-013&orientation=landscape",
    summary:
      "在被极夜笼罩的北方小城，一名刑警追查一桩跨越十二年的悬案。随着线索逐渐串起，他发现真相与自己最信任的人息息相关。",
  },
  {
    id: "m014",
    title: "南风知我意",
    type: "电视剧",
    year: 2024,
    country: "中国",
    genres: ["都市", "爱情", "剧情"],
    actors: ["纪舟", "沈念", "温朗"],
    director: "苏合",
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20poster%2C%20two%20figures%20silhouette%20standing%20apart%20on%20a%20windy%20seaside%20at%20dusk%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20teal%20and%20soft%20rose%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-014&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20windy%20seaside%20promenade%20at%20dusk%20with%20warm%20distant%20lights%2C%20romantic%20atmosphere%2C%20deep%20teal%20and%20soft%20rose%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-014&orientation=landscape",
    summary:
      "多年后重逢的两个人，在各自的人生轨迹里重新靠近。这部剧以细腻的日常笔触，讲述了一段关于成长、理解与重逢的都市情感故事。",
  },
  {
    id: "m015",
    title: "海上来信",
    type: "电影",
    year: 2024,
    country: "中国",
    genres: ["剧情", "文艺"],
    actors: ["陆青禾", "周漾"],
    director: "陈屿",
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20art%20film%20poster%2C%20a%20lone%20figure%20sitting%20on%20a%20wooden%20dock%20facing%20a%20calm%20sea%20at%20dawn%2C%20minimalist%2C%20soft%20lighting%2C%20deep%20teal%20and%20pale%20gold%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-015&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20calm%20sea%20at%20dawn%20with%20a%20lone%20wooden%20dock%20and%20soft%20mist%2C%20serene%20atmosphere%2C%20deep%20teal%20and%20pale%20gold%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-015&orientation=landscape",
    summary:
      "一位独居海边的老人，每天都会收到一封没有寄件人的信。信件的内容将他带回年轻时的那段往事，也让一个尘封多年的秘密重见天日。",
  },
  {
    id: "m016",
    title: "暗夜航班",
    type: "电视剧",
    year: 2025,
    country: "美国",
    genres: ["惊悚", "悬疑", "剧情"],
    actors: ["瑞恩·科尔", "艾拉·斯通"],
    director: "马克·雷诺兹",
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20thriller%20poster%2C%20an%20airplane%20silhouette%20against%20a%20dark%20stormy%20night%20sky%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20cold%20cyan%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-016&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20stormy%20sky%20with%20distant%20airplane%20lights%20at%20night%2C%20tense%20atmosphere%2C%20deep%20navy%20and%20cold%20cyan%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-016&orientation=landscape",
    summary:
      "一架深夜航班在穿越风暴时与地面失去联系，机上乘客逐渐发现，他们中的每一个人都与一桩旧案有关。",
  },
  {
    id: "m017",
    title: "厨房奇遇记",
    type: "综艺",
    year: 2024,
    country: "中国",
    genres: ["美食", "真人秀"],
    actors: ["群星嘉宾"],
    director: "节目组",
    rating: 7.7,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20food%20variety%20show%20poster%2C%20a%20chef%20silhouette%20working%20in%20a%20warm%20lit%20kitchen%20with%20rising%20steam%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20brown%20and%20warm%20amber%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-017&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm%20rustic%20kitchen%20with%20cooking%20steam%20and%20ambient%20light%2C%20cozy%20atmosphere%2C%20deep%20brown%20and%20warm%20amber%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-017&orientation=landscape",
    summary:
      "明星嘉宾走进不同城市的街边小店，向民间厨艺高手学习招牌菜。在烟火气里，记录食物背后的故事与人情。",
  },
  {
    id: "m018",
    title: "时间褶皱",
    type: "电影",
    year: 2025,
    country: "英国",
    genres: ["科幻", "剧情"],
    actors: ["奥利弗·班克斯", "郑夏"],
    director: "克拉拉·诺兰",
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20drama%20poster%2C%20a%20lone%20figure%20standing%20before%20a%20giant%20glowing%20circular%20portal%20in%20a%20dark%20void%2C%20minimalist%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20violet%20cyan%20grading%2C%20simple%20dark%20background%2C%20high%20detail&width=600&height=900&seq=bajie-poster-018&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20sci-fi%20scene%20of%20a%20glowing%20circular%20portal%20in%20a%20dark%20void%2C%20mysterious%20atmosphere%2C%20deep%20navy%20and%20violet%20cyan%20grading%2C%20simple%20composition%2C%20high%20detail&width=1280&height=720&seq=bajie-cover-018&orientation=landscape",
    summary:
      "物理学家在一次实验中意外打开了一道通往过去的时间缝隙。为了挽回一段无法释怀的遗憾，他一次次回到同一个下午，却发现改变过去需要付出的代价远超想象。",
  },
];